import { createRouter, createWebHistory } from "vue-router";
import { getAuth } from "firebase/auth";

import DashboardAdmin from "../src/views/DashboardAdmin.vue";
import DashboardSMRmaster from "./views/DashboardSMRMaster.vue";
import DashboardReferee from "../src/views/DashboardReferee.vue";
import DashboardRefCoach from "../src/views/DashboardRefCoach.vue";
import LoginPage from "../src/views/LoginPage.vue";
import SignupPage from "../src/views/SignupPage.vue";
import MatchReport from "../src/views/MatchReport.vue";
import Maintain_Leagues from "./views/Maintain_Leagues.vue";
import Maintain_GenderAges from "../src/views/Maintain_GenderAges.vue";
import Maintain_MisconductCodes from "./views/Maintain_MisconductCodes.vue";
import Misconduct_Referee from "./views/Misconduct_Referee.vue";
import Misconduct_RefCoach from "../src/views/Misconduct_RefCoach.vue";
import Misconduct_Admin from "./views/Misconduct_Admin.vue";
import Maintain_GameSchedule from "./views/Maintain_GameSchedule.vue";
import Maintain_Users from "../src/views/Maintain_Users.vue";
import Metrics from "../src/views/Metrics.vue";
import HelpPage from "../src/views/Help.vue";

const routes = [
  { path: "/", redirect: "/login" },
  { path: "/login", component: LoginPage, meta: { hideTopBar: true } },
  { path: "/not-authorized", redirect: "/login" },
  { path: "/signup", component: SignupPage, meta: { hideTopBar: true } },

  { path: "/dashboard-SMRmaster", component: DashboardSMRmaster, meta: { requiresAuth: true } },
  { path: "/dashboard-admin", component: DashboardAdmin, meta: { requiresAuth: true, roles: ["ADMIN"], navbar: "admin" } },
  { path: "/dashboard-refcoach", component: DashboardRefCoach, meta: { requiresAuth: true, roles: ["RefereeCoach"], navbar: "refcoach" } },
  { path: "/dashboard-referee", component: DashboardReferee, meta: { requiresAuth: true, roles: ["Referee"], navbar: "referee" } },

  { path: "/matchreport/:id?", name: "MatchReport", component: MatchReport, meta: { requiresAuth: true, roles: ["Referee","RefereeCoach", "ADMIN"] } },

  { path: "/maintain-leagues", component: Maintain_Leagues },
  { path: "/maintain-genderages", component: Maintain_GenderAges, meta: { requiresAuth: true, roles: ["ADMIN"] } },
  { path: "/maintain-misconductcodes", component: Maintain_MisconductCodes, meta: { requiresAuth: true, roles: ["ADMIN"] } },

  { path: "/misconduct-referee", component: Misconduct_Referee, meta: { requiresAuth: true, roles: ["Referee"] } },
  { path: "/misconduct-refcoach", component: Misconduct_RefCoach, meta: { requiresAuth: true, roles: ["RefereeCoach"] } },
  { path: "/misconduct-admin", component: Misconduct_Admin, meta: { requiresAuth: true, roles: ["ADMIN"] } },

  { path: "/maintain-gameschedule", component: Maintain_GameSchedule, meta: { requiresAuth: true, roles: ["ADMIN"] } },
  { path: "/maintain-users", component: Maintain_Users, meta: { requiresAuth: true, roles: ["ADMIN"] } },

  { path: "/metrics", component: Metrics, meta: { requiresAuth: true } },
  { path: "/help", component: HelpPage, meta: { requiresAuth: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// --- helpers ---
function normalizeRole(r) {
  return r === "ADMIN" || r === "RefereeCoach" || r === "Referee" ? r : "Referee";
}
function dashboardFor(role) {
  switch (normalizeRole(role)) {
    case "ADMIN": return "/dashboard-admin";
    case "RefereeCoach": return "/dashboard-refcoach";
    case "Referee":
    default: return "/dashboard-referee";
  }
}

// Single guard based on Firebase custom claims
router.beforeEach(async (to, _from, next) => {
  const requiresAuth = to.meta?.requiresAuth === true;
  const requiredRoles = to.meta?.roles || null;

  if (!requiresAuth) return next();

  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }

  try {
    // Get the user's SELECTED role from localStorage (set during login)
    const selectedRole = localStorage.getItem("currentUserRole");

    // Fresh claims (your 'setActiveOrgRole' should have stamped claims.role)
    const idt = await user.getIdTokenResult(true);
    const claims = idt.claims || {};
    
    // Use selected role if available, otherwise fall back to claims
    const userRole = normalizeRole(selectedRole || claims.role || "");
    
    // Always steer any dashboard path to the user's dashboard
    if (to.path.startsWith("/dashboard")) {
      const want = dashboardFor(userRole);
      if (to.path !== want) return next(want);
    }

    // Enforce per-route role gates if present
    if (requiredRoles && (!userRole || !requiredRoles.includes(userRole))) {
      // Not authorized for this route → send to user's dashboard instead of root
      return next(dashboardFor(userRole));
    }

    return next();
  } catch (_e) {
    // Fail-safe to login
    return next({ path: "/login", query: { redirect: to.fullPath } });
  }
});

export default router;
